import { apiFunction } from "../../apiCall/function"

export const getChapter = async (code, lang) => {
  return await apiFunction("question/0?subject_id=" + code + "&lang=" + lang, "get", {}, false, 'body')
}